import { env } from '../../config/runtime';

const domain = env.waipuDomain;

export const SocialMediaLink = {
  Facebook: 'https://www.facebook.com/waipu.tv',
  Instagram: 'https://www.instagram.com/waipu.tv',
  YouTube: 'https://www.youtube.com/channel/UCM8k2fsf7zhm2uhEeRuv6nA',
  X: 'https://twitter.com/waiputv',
} as const;

export const LegalLink = {
  Imprint: `https://www.${domain}/impressum`,
  AGB: `https://www.${domain}/agb`,
  DataProtection: `https://www.${domain}/datenschutz`,
  /** Datenschutzerklärung — also the SCHUFA / credit-check disclosure. */
  DataUsage: `https://www.${domain}/dse`,
  Cancellation: `https://microsite.${domain}/waipu/kuendigung`,
  Transparency: `https://microsite.${domain}/waipu/transparenzhinweise/`,
  CEDeclaration: `https://www.${domain}/deklarationen/`,
  Accessibility: `https://www.${domain}/barrierefreiheit`,
  DataAct: `https://www.${domain}/data-act`,
};

export const AboutLink = {
  Offers: `https://www.${domain}/angebote`,
  Netflix: `https://www.${domain}/netflix`,
  Options: `https://www.${domain}/optionen`,
  HD: `https://www.${domain}/hd-fernsehen`,
};

// Brand URL — always points at the public `waipu.tv` site, ignoring the runtime `waipuDomain`.
// Use when copy refers to the *brand* ("Verwenden Sie dieses Passwort nur für waipu.tv"), not
// when navigating the user to a page under their current environment.
export const WAIPU_BRAND_HOME = 'https://www.waipu.tv/';

export const PlayerLink = `https://play.${domain}`;

export const AppDownloadLink = {
  Apple: 'https://apps.apple.com/de/app/waipu-tv-live-tv-streaming/id1119988075',
  GooglePlay: 'https://play.google.com/store/apps/details?id=de.exaring.waipu',
};

export const ServiceLink = {
  Help: `https://www.${domain}/hilfe`,
  FAQ: `https://www.${domain}/hilfe/#faq`,
  Contact: `https://www.${domain}/hilfe/tickets/new`,
  Registration: `https://client.${domain}/customer-funnel/registration?product=perfect-plus`,
  PasswordHelp: `https://www.${domain}/hilfe/articles/360016251158`,
};

export const CompanyLink = {
  About: 'https://www.exaring.de',
  Careers: 'https://www.exaring.de/#karriere',
  Press: `https://www.${domain}/presse`,
  Advertising: 'https://www.exaring.de/#werbevermarktung',
};
